import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingControlWidgetWidget } from '../../../../../services/ControlWidgetService.service';




@Component({
  selector: 'function-number-autocomplete-input-control-widget-menu-settings',
  templateUrl: 'function-number-autocomplete-input-control-widget-menu-settings.component.html',
  styleUrls: ['./function-number-autocomplete-input-control-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class FunctionNumberAutoCompleteInputControlWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      
    }


}



